module.exports = __webpack_public_path__ + "static/media/nexatlas-mobile.f1279276.svg";